import { render, staticRenderFns } from "./ConsumptionDataExchange.vue?vue&type=template&id=a82d754e&lang=pug&"
import script from "./ConsumptionDataExchange.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports